import { render, staticRenderFns } from "./TKPendingRequest.vue?vue&type=template&id=0fa308a0&scoped=true"
import script from "./TKPendingRequest.vue?vue&type=script&lang=js"
export * from "./TKPendingRequest.vue?vue&type=script&lang=js"
import style0 from "./TKPendingRequest.vue?vue&type=style&index=0&id=0fa308a0&prod&lang=css&scoped=true"
import style1 from "./TKPendingRequest.vue?vue&type=style&index=1&id=0fa308a0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa308a0",
  null
  
)

export default component.exports